import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment.prod';
@Injectable({
   providedIn: 'root'
})

export class UserService {
   private _userUserListUrl = `${environment.api}/User/getuserList`;
   private _UserListByIdUrl = `${environment.api}/User/getuserListById`;
   private _UserListByIdMobUrl = `${environment.api}/User/getuserListByIdMob`;
   private _activeUserUrl = `${environment.api}/User/statusUserById`;
   private _addUserUrl = `${environment.api}/User/addUser`;
   private _getUserInfoUrl = `${environment.api}/User/getUserInfo`;
   private _displayDate = `${environment.api}/User/displayDate`;
   private _updateUserUrl = `${environment.api}/User/updateUser`;
   private _getUserCustomerUrl = `${environment.api}/User/getUserCustomer`;
   private _addInvoice = `${environment.api}/SoaImage/saveInvoiceItem`;
   private _forgotPasswordUrl = `${environment.api}/User/forgotPassword`;

   private _sendEmailToUserUrl = `${environment.api}/User/sendEmailToUser`;

   private _getUserInfoByIdUrl = `${environment.api}/User/getUserInfoById`;

   private _getUserInfoForP = `${environment.api}/User/getUserInfoForP`;

   private _sendSmsToUserUrl = `${environment.api}/User/sendSmsToUser`;
   private _getrolesadmin = `${environment.api}/User/getrolesadmin`;

   private _sendSmsToAdditionalUserUrl = `${environment.api}/User/sendSmsToAdditionalUser`;
   private _getpassword = `${environment.api}/User/getUserPassword`;

   private _getSSettingInfoUrl = `${environment.api}/User/getSSettingInfo`;
   private _updateSSettingUrl = `${environment.api}/User/updateSSetting`;

   // private _updateBankUrl = `${environment.api}/User/updateBank`; // by deep

   constructor(private http: HttpClient) { }

   getUserInfoById(data) {
      return this.http.post<any>(this._getUserInfoByIdUrl, data);
   }
   displayDate(data) {
      return this.http.post<any>(this._displayDate, data);
   }

   getUserInfoForP(data) {
      return this.http.post<any>(this._getUserInfoForP, data);
   }

   sendEmailToUser(data) {
      return this.http.post<any>(this._sendEmailToUserUrl, data);
   }

   getUserList(data) {
      return this.http.post<any>(this._userUserListUrl, data);
   }

   getUserListByid(data) {
      return this.http.post<any>(this._UserListByIdUrl, data);
   }

   getuserListByIdMob(data) {
      return this.http.post<any>(this._UserListByIdMobUrl, data);
   }

   addUser(data) {
      return this.http.post<any>(this._addUserUrl, data);
   }

   getUserInfo(data) {
      return this.http.post<any>(this._getUserInfoUrl, data);
   }

   updateUSer(data) {
      return this.http.post<any>(this._updateUserUrl, data);
   }

   activeuser(data) {
      return this.http.post<any>(this._activeUserUrl, data);
   }

   getUserCustomer(data) {
      return this.http.post<any>(this._getUserCustomerUrl, data);
   }

   forgotPassword(data) {
      return this.http.post<any>(this._forgotPasswordUrl, data);
   }

   sendSmsToUser(data) {
      return this.http.post<any>(this._sendSmsToUserUrl, data);
   }

   sendSmsToAdditionalUser(data) {
      return this.http.post<any>(this._sendSmsToAdditionalUserUrl, data);
   }
   getrolesadmin(data) {
      return this.http.post<any>(this._getrolesadmin, data);
   }
   addInvoice(data) {
      return this.http.post<any>(this._addInvoice, data);
   }
   getpassword(data) {
      return this.http.post<any>(this._getpassword, data);
   }

   //added by deepak on 18/08/2022 for get super admin settings
   getSSettingInfo(data) {
      return this.http.post<any>(this._getSSettingInfoUrl, data);
   }

   //added by deepak on 18/08/2022 for update super admin settings
   updateSSetting(data) {
      return this.http.post<any>(this._updateSSettingUrl, data);
   }

   // updateBank(data) {
   //    return this.http.post<any>(this._updateBankUrl, data);
   // }
}
